export default '/pricing/special-offer';
